import VendorForm from './VendorForm'
export default VendorForm
